export default __webpack_public_path__ + "postMock-1748658993194.html";